import { generateClient, GraphQLResult } from "aws-amplify/api";
import { copyImageRoute as copyImageRouteGql } from "graphql/mutations";
import { ImageProcessingResult } from "utils/s3/handleToolboxResponse";

/**
 * Given the key of the image we want to copy and the user's auth token, calls the copyImage route on the toolbox
 * @author Eric Webb <ewebb@factorearth.com>
 * @param key The key of the image we want to copy
 * @param authToken The user's auth token
 * @returns The response from the toolbox
 */
async function copyImageRoute(key: string): Promise<ImageProcessingResult> {
	interface QueryResponse {
		copyImageRoute: ImageProcessingResult;
	}
	const client = generateClient({ authMode: "userPool" });
	const response = (await client.graphql({
		query: copyImageRouteGql,
		authMode: "userPool",
		variables: {
			key,
		},
	})) as GraphQLResult<QueryResponse>;
	return response.data.copyImageRoute;
}

export default copyImageRoute;
